export default __webpack_public_path__ + "static/media/head.4ce2fe6c.svg";